import { queryOptions } from '@tanstack/react-query';
import _ from 'lodash';
import { useContext } from 'react';

import { AssociationParameters } from 'app/interfaces/PACSCommunication';
import { PACSCommunication } from 'app/interfaces/PACSCommunication';
import { PACSCommunicationContext } from 'app/components/PACSCommunicationProvider/context';
import { ABSTRACT_SYNTAXES_WITH_ROLE } from 'app/components/PACSAssociationStatus/ABSTRACT_SYNTAXES_WITH_ROLE';
import { DicomRegistry } from 'app/interfaces/DicomRegistry';

type Dependencies = {
  pacsCommunication: PACSCommunication;
};

export function addAllPresentationContextsToConfiguration(parameters: AssociationParameters) {
  return {
    ...parameters,
    presentationContexts: ABSTRACT_SYNTAXES_WITH_ROLE.map(([abstractSyntax, role]) => ({
      abstractSyntax,
      transferSyntaxes: [DicomRegistry.ImplicitVRLittleEndian],
      role,
    })),
  };
}

export default function queryPACSAssociationStatusOptions(
  params: AssociationParameters,
  dependencies?: Dependencies
) {
  const filteredParams = _.pick(params, [
    'hostIP',
    'port',
    'hostAETitle',
    'selfAETitle',
    'username',
    'password',
    'presentationContexts',
  ]);
  const pacsCommunicationCtx = useContext(PACSCommunicationContext);
  const pacsCommunication = dependencies?.pacsCommunication ?? pacsCommunicationCtx;

  return queryOptions({
    networkMode: 'always',
    queryKey: [{ query: 'PACSAssociationStatus' }, filteredParams] as const,
    queryFn: async ({ queryKey }) => {
      const [, associationParameters] = queryKey;
      return await pacsCommunication.checkAssociation(associationParameters);
    },
  });
}
